<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" ref="MainForm" />
</template>

<script setup>
/**
 * TTMMultiphasePumpForm
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';
import { ref, computed } from 'vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});
const MainForm = ref(null);

const buttons = computed(() => [
  {
    key: 'FACILITY_RUN',
    loadedValue: 'COMMAND_ON',
    index: 15,
    name: 'Запуск',
    click: () => MainForm.value?.writeLoadedValue('FACILITY_RUN', 'COMMAND_ON', 0),
  },
  {
    key: 'FACILITY_STOP',
    loadedValue: 'COMMAND_ON',
    index: 16,
    name: 'Стоп',
    click: () => MainForm.value?.writeLoadedValue('FACILITY_STOP', 'COMMAND_ON', 0),
  },
  {
    key: 'RESET_ALARM',
    index: 11,
    loadedValue: 'COMMAND_ON',
    name: 'Сброс аварии',
    click: () => MainForm.value?.writeLoadedValue('RESET_ALARM', 'COMMAND_ON', null),
  },
  {
    key: 'WORK_MODE',
    name: 'Режим ПЧ',
    component: 'Dropdown',
    attrList: {
      options: [
        { name: 'Автоматический', value: 0 },
        { name: 'Ручной', value: 1 },
      ],
      placeholder: 'Режим',
      appendTo: 'body',
      optionLabel: 'name',
      optionValue: 'value',
      style: { 'min-width': '160px', height: '24px' },
    },
  },
  {
    key: 'WORK_MODE',
    name: 'Выполнить',
    click: () => {
      const prop = MainForm.value?.getPropertyDB('WORK_MODE');     
      const controlsValue = MainForm.value?.controlsValue;
      if (controlsValue?.['WORK_MODE'] === 0) {
        if (prop?.property_data_values?.['COMMAND_OFF'])
          return MainForm.value?.write('WORK_MODE', prop.property_data_values['COMMAND_OFF']);
        else return MainForm.value?.write('WORK_MODE', 0);
      } else if (controlsValue?.['WORK_MODE'] === 1) {
        if (prop?.property_data_values?.['COMMAND_ON'])
          return MainForm.value?.write('WORK_MODE', prop.property_data_values['COMMAND_ON']);
        else return MainForm.value?.write('WORK_MODE', 1);
      }
    },
  },
]);

const defaultDesign = FORM_DESIGNS.TTMMultiphasePumpForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMMultiphasePumpForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMMultiphasePumpForm;
</script>
